(function ($) {
   if (document.readyState !== "loading") {
      main_init();
   } else {
      document.addEventListener("DOMContentLoaded", function () {
         main_init();
      });
   }

   function main_init() {
      //POP-UP
      jQuery(document).ready(function ($) {
         var popupId = "#pum-563";

         if (window.location.pathname.startsWith("/transaktioner/")) {
            var openPopupWhenReady = setInterval(function () {
               if (typeof PUM !== "undefined" && $(popupId).length > 0) {
                  PUM.open(563);
                  clearInterval(openPopupWhenReady);
               }
            }, 100);
         } else {
            setInterval(function () {
               // console.log("Should remove!");
               $(popupId).remove();
               $("html").removeClass("pum-open pum-open-overlay pum-open-scrollable");
            }, 100);
         }

         $(document).on("pumAfterOpen", function (event) {
            var popup = event.target;

            if ($(popup).attr("id") !== popupId.substring(1)) return;

            $("html").removeClass("pum-open pum-open-overlay pum-open-scrollable");

            if (!window.location.pathname.startsWith("/transaktioner/")) {
               $(popup).remove();
               return;
            }

            var $btnContainer = $(popup).find(".pum-close");

            if ($btnContainer.length === 0) {
               console.warn("Hittade inte stängknappen");
               return;
            }

            if ($(popup).find(".popup-button-row").length === 0) {
               // Bekräfta-knapp
               var $mainBtn = $btnContainer
                  .clone()
                  .removeClass("pum-close")
                  .addClass("confirm-btn")
                  .on("click", function () {
                     $("#popmake-563" && "#pum-563").remove();
                     $(".pum-trigger.popmake-563").css("cursor", "default");
                  });

               // Avbryt-knapp
               var $cancelBtn = $mainBtn
                  .clone()
                  .removeClass("confirm-btn")
                  .addClass("cancel-btn")
                  .html("AVBRYT")
                  .off("click")
                  .on("click", function () {
                     window.location.href = "team/#kontakt";
                  });

               var $buttonRow = $('<div class="popup-button-row"></div>');
               $buttonRow.append($mainBtn, $cancelBtn);

               $btnContainer.hide();

               $btnContainer.parent().append($buttonRow);
            }
         });
      });
      //Go to #kontakt on Team page
      jQuery(document).ready(function ($) {
         $(document).on("click", ".go-to-contact-btn", function (e) {
            window.location.href = "team/#kontakt";
         });
      });

      //animation on logo (services-page)
      $(document).ready(function () {
         function triggerColumnContent() {
            const container = $(".columns-wrapper");
            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();
            if (container.length) {
               const containerTop = container.offset().top;
               const triggerPoint = containerTop - windowHeight + 100;

               if (scrollTop > triggerPoint) {
                  const $leftColumn = $(".column-left");
                  const $rightColumn = $(".column-right");
                  const $underLine = $(".services-line");

                  $leftColumn.addClass("visible");

                  setTimeout(() => {
                     $rightColumn.addClass("visible");
                     setTimeout(() => {
                        $underLine.addClass("visible");
                     }, 400);
                  }, 600);

                  $(window).off("scroll", triggerColumnContent);
               }
            }
         }

         $(window).on("scroll", triggerColumnContent);

         function triggerLogoFade() {
            const $logo = $(".nordicap-image-logo-section3");
            const $triggerSection = $(".services-media-wrapper");
            if ($triggerSection.length) {
               const sectionOffsetTop = $triggerSection.offset().top;
               const sectionHeight = $triggerSection.outerHeight();
               const triggerPoint = sectionOffsetTop + sectionHeight / 3;

               const scrollTop = $(window).scrollTop();
               const windowHeight = $(window).height();

               if (scrollTop + windowHeight >= triggerPoint) {
                  $logo.addClass("visible");
                  $(window).off("scroll", triggerLogoFade);
               }
            }
         }

         $(window).on("scroll", triggerLogoFade);
      });

      const coverHeaderSpecial = $(".cover-header-special");
      if (coverHeaderSpecial.length) {
         $("header").addClass("header-special");
         const coverHeaderSpecialHeight = coverHeaderSpecial.outerHeight();
         $("body").css("--hero-height", `${coverHeaderSpecialHeight}px`);
      }

      //JQuery scroll header
      // const $header = $("header");
      // const triggerOffset = $(".wp-block-cover").outerHeight();

      // $(window).on("scroll", function () {
      //    if ($(this).scrollTop() >= triggerOffset) {
      //       $header.addClass("fixed");
      //    } else {
      //       $header.removeClass("fixed");
      //    }
      // });

      const $header = $("header");
      const $hero = $(".video-start-page.cover-header-special");

      $(window).on("scroll", function () {
         const scrollTop = $(this).scrollTop();
         const heroHeight = $hero.outerHeight();

         if (scrollTop >= heroHeight) {
            $header.addClass("fixed");
         } else {
            $header.removeClass("fixed");
         }
      });

      // $(document).on("click", ".wp-block-navigation__responsive-container-open", function () {
      //    const isHome = $("body").hasClass("home");
      //    const $header = $("header");
      //    const $hero = $(".video-start-page.cover-header-special");
      
      //    if (!isHome || !$hero.length) return;
      
      //    const heroHeight = $hero.outerHeight();
      
      //    // scrolla bit past the hero to ensure the header becomes fixed
      //    $("html, body").animate(
      //       { scrollTop: heroHeight },
      //       200,
      //       function () {
      //          // Ensure the header is fixed after the animation
      //          $header.addClass("fixed");
      //       }
      //    );
      // });

      $(document).on("click", ".wp-block-navigation__responsive-container-open", function () {
         const isHome = $("body").hasClass("home");
         const $header = $("header");
         const $hero = $(".video-start-page.cover-header-special");
      
         if (!isHome || !$hero.length) return;
      
         const heroHeight = $hero.outerHeight();
         const scrollTop = $(window).scrollTop();
      
         // 👇 bara scrolla om vi INTE redan är förbi hero
         if (scrollTop < heroHeight) {
            $("html, body").animate(
               { scrollTop: heroHeight },
               200,
               function () {
                  $header.addClass("fixed");
               }
            );
         }
      });

      $(document).ready(function () {
         const leftRows = $(".services-column-wrapper.section1-left .services-rows > div");
         const rightRows = $(".services-column-wrapper.section1-right .services-rows > div");
         const section = $(".icon-box--number");
         function isInView(el) {
            const rect = el[0].getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
         }

         function animateRows() {
            leftRows.each(function (i) {
               setTimeout(() => {
                  $(this).addClass("visible");
               }, i * 200);
            });

            setTimeout(
               () => {
                  rightRows.each(function (i) {
                     setTimeout(() => {
                        $(this).addClass("visible");
                     }, i * 200);
                  });
               },
               leftRows.length * 200 + 300
            );
         }

         function onScroll() {
            if (isInView(section)) {
               animateRows();
               $(window).off("scroll", onScroll);
            }
         }

         if (section.length) {
            $(window).on("scroll", onScroll);
            onScroll();
         }
      });

      // JQuery scroll animation function

      function initZoomOnScroll() {
         const isDesktop = window.matchMedia("(min-width: 650px)").matches;

         $("figure.zoom-on-scroll").each(function () {
            const $fig = $(this);
            const $img = $fig.find("img");

            if (!isDesktop) {
               $img.css({
                  width: "auto",
                  height: "100%",
                  transition: "",
               });
               return;
            }

            const startWidth = 60;
            const endWidth = 100;
            const startHeight = 100;
            const endHeight = 120;

            const imgTop = $img.offset().top;
            const imgH = $img.outerHeight();
            const $win = $(window);

            $img.css({
               transition: "width 0s ease-in-out, height 0s ease-in-out",
            });

            $win.off("scroll.zoom").on("scroll.zoom resize.zoom", function () {
               const scrollTop = $win.scrollTop();
               const winH = $win.height();
               const visible = scrollTop + winH - imgTop;
               const total = (winH + imgH) / 2;
               const progress = Math.max(0, Math.min(1, visible / total));

               const newWidth = startWidth + (endWidth - startWidth) * progress;
               const newHeight = startHeight + (endHeight - startHeight) * (progress * 2);

               $img.css({
                  width: newWidth + "%",
                  height: newHeight + "%",
               });
            });
         });
      }

      initZoomOnScroll();

      $(window).on("resize", function () {
         $(window).off("scroll.zoom resize.zoom");
         initZoomOnScroll();
      });

      // make screen un-scrollable when header search is open
      $("header .wp-block-search button").on("click", function () {
         if (!$("html").hasClass("has-modal-open")) {
            $("html").addClass("has-modal-open");
         }
      });

      // make screen scrollable when header search is closed
      $("header .wp-block-search input").on("focusout", function () {
         if ($("html").hasClass("has-modal-open")) {
            $("html").removeClass("has-modal-open");
         }
      });

      // Function to scroll smoothly to the element
      function smoothScrollToHash(hash) {
         var target = $(hash);
         // console.log(target);
         if (target.length) {
            setTimeout(() => {
               $("html, body").animate(
                  { scrollTop: target.offset().top - 100 },
                  800 // Duration in milliseconds
               );
            }, 250);
         }
      }

      // Scroll on page load if there's a hash in the URL
      if (window.location.hash) {
         smoothScrollToHash(window.location.hash);
      }

      // Smooth scrolling when clicking anchor links
      $('a[href^="#"]').on("click", function (e) {
         e.preventDefault();
         var hash = this.hash;
         if (hash) {
            smoothScrollToHash(hash);
            history.pushState(null, null, hash); // Update URL without reloading
         }
      });
   }
})(jQuery);
